import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS class strings with conflict resolution.
 * Later classes override earlier ones (e.g. `cn('text-white', 'text-gray-900')` → 'text-gray-900').
 */
export function cn(...inputs: (string | undefined | null | false)[]): string {
  return twMerge(inputs.filter(Boolean).join(' '));
}
